import { render, staticRenderFns } from "./ContentBox.vue?vue&type=template&id=0a0aaa02&scoped=true"
import script from "./ContentBox.vue?vue&type=script&lang=js"
export * from "./ContentBox.vue?vue&type=script&lang=js"
import style0 from "./ContentBox.vue?vue&type=style&index=0&id=0a0aaa02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0aaa02",
  null
  
)

export default component.exports